import { render, staticRenderFns } from "./VendorDeleteModal.vue?vue&type=template&id=12bed4bd&scoped=true&"
import script from "./VendorDeleteModal.vue?vue&type=script&lang=js&"
export * from "./VendorDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bed4bd",
  null
  
)

export default component.exports